export interface Category {
  id: string;
  name: string;
  url: string;
}

export const categories: Category[] = [
  { id: "shoes", name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { id: "hoodies", name: "Hoodies / Sweaters", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" },
  { id: "tshirts", name: "T-Shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html" },
  { id: "jackets", name: "Jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html" },
  { id: "pants", name: "Pants / Shorts", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html" },
  { id: "headwear", name: "Headwear", url: "https://kaspreadsheet.com/category-916-Headwear.html" },
  { id: "sets", name: "Sets", url: "https://kaspreadsheet.com/category-917-Sets.html" },
  { id: "underwear", name: "Underwear / Underpants", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html" },
  { id: "jersey", name: "Jersey", url: "https://kaspreadsheet.com/category-919-Jersey.html" },
  { id: "accessories", name: "Accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html" },
  { id: "bags", name: "Bags", url: "https://kaspreadsheet.com/category-921-Bags.html" },
  { id: "belts", name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Bags.html" },
  { id: "perfumes", name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Bags.html" },
  { id: "otherstuff", name: "OtherStuff", url: "https://kaspreadsheet.com/search-924/name/Bags.html" },
];